module.exports = __webpack_public_path__ + "media/images/laboratory_dark-a9646ce910d22acd31ac0cb8ecbf6f4e.png";